import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  _getUnPaidTimesheet,
  _saveInvoiceAdjustment,
} from "@/services/timesheet";
import { handleAPICatch, showErrorToast } from "@/utilities/utils";

import {
  toggleInvoiceTimesheetModal,
  updateSelectedCandidate,
  updateSelectedSignOffIds,
} from "./timesheetauthorised";

const initialState = {
  isLoading: false,
  isPaginationLoading: false,
  invoiceCreationData: [],
  selectedTimesheetGroupIds: [],
};

export const fetchUnPaidTimesheet = createAsyncThunk(
  "timesheetsInvoiceCreation/fetchUnPaidTimesheet",
  async (data, { dispatch, getState }) => {
    const response = _getUnPaidTimesheet(data);
    response
      .then((res) => {
        const unpaid_invoices = res?.data?.unpaid_invoices;
        dispatch(updateInvoiceCreationData(unpaid_invoices));
        if (unpaid_invoices.length > 0) {
          dispatch(toggleInvoiceTimesheetModal(true));
        } else {
          showErrorToast(
            "This contract has pending timesheets. Please approve them before creating an invoice.",
          );
          dispatch(updateSelectedTimesheetGroupIds([]));
          dispatch(updateSelectedSignOffIds([]));
          dispatch(updateSelectedCandidate([]));
          return;
        }
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

export const saveInvoiceAdjustment = createAsyncThunk(
  "timesheetsInvoiceCreation/saveInvoiceAdjustment",
  async (data, { dispatch, getState }) => {
    console.log(data);
    const response = _saveInvoiceAdjustment(data);
    response
      .then((res) => {
        dispatch(toggleInvoiceTimesheetModal(false));
      })
      .catch((error) => {
        handleAPICatch(error);
      });
  },
);

const invoiceCreationSlice = createSlice({
  name: "invoiceCreation",
  initialState,
  reducers: {
    updateInvoiceCreationData: (state, action) => {
      state.invoiceCreationData = action.payload;
    },
    setInvoiceCreationLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setInvoiceCreationPaginationLoading: (state, action) => {
      state.isPaginationLoading = action.payload;
    },
    updateSelectedTimesheetGroupIds: (state, action) => {
      state.selectedTimesheetGroupIds = action.payload;
    },
  },
});

export const {
  updateSelectedTimesheetGroupIds,
  updateInvoiceCreationData,
  setInvoiceCreationLoading,
  setInvoiceCreationPaginationLoading,
} = invoiceCreationSlice.actions;

export default invoiceCreationSlice.reducer;
